import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import axiosClient from '../../../../../shared/axios/axios-client';

@Component({
  selector: 'app-validar-link',
  templateUrl: './validar-link.html',
  styleUrls: ['./validar-link.scss'],
})
export class ValidarLink implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute) {}

  async ngOnInit(): Promise<void> {
    const email = this.route.snapshot.queryParamMap.get('email');
    const id = this.route.snapshot.queryParamMap.get('id');

    if (!email || !id) {
      this.router.navigate(['/auth/primeiro-acesso/link-expirado']);
      return;
    }

    await axiosClient
      .get(`/auth/primeiro-acesso/validar/${id}`)
      .then((response) => {
        const { valido } = response.data;
        if (valido) {
          sessionStorage.setItem('primeiroAcessoId', id);
          sessionStorage.setItem('primeiroAcessoEmail', email); // se quiser guardar
          this.router.navigate(['/auth/primeiro-acesso/link-liberado']);
        } else {
          this.router.navigate(['/auth/primeiro-acesso/link-expirado']);
        }
      })
      .catch(() => {
        this.router.navigate(['/auth/primeiro-acesso/link-expirado']);
      });
  }
}
